module.exports = __webpack_public_path__ + "static/media/Althea_care_uses_Curoflow_telemedicine_platform.297d9dc9.webp";